// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Managers
//import ColorManager from '../styles/ColorManager';

// Components
//import StatCard from '../components/StatCard';
import Grid from '@material-ui/core/Grid';
import DataTable from '../components/DataTable';
import Typography from '@material-ui/core/Typography';
//import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  cardFilter: any;
  cards: any;
}

interface Props {
  location: any;
  navigation: any;
}

/**
 * @description Borrows View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class Camp extends React.Component<Props, State> {

  /**
   * Creates an instance of Borrows.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    document.title = "Rouges-Terres | Camps";
  }

  /**
   * @description Render the BorrowsView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const columns = [
      { id: 'id', numeric: true, disablePadding: false, label: 'Id' },
      { id: 'title', numeric: false, disablePadding: false, label: 'Nom' }
    ];
    const actions = [
      "close",
      "update"
    ];

    return (
      <div>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={12}>
            <Typography variant="headline" gutterBottom={true}>Camps</Typography>
          </Grid>
          <Grid item={true} xs={12}>
            <Typography variant="body1" gutterBottom={true} style={{marginBottom: 16}}>Il s'agit des 2 types de camps.</Typography>
          </Grid>
        </Grid>

        <DataTable title="Les camps" actions={actions} columns={columns} rows="camp" apiPath="camp"
          isPossibleToFilter={false} urlPath="Camps" />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Camp.tsx